/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'sidebar.smartstock': 'Smart Stock',
    'sidebar.etapas': 'Etapas',
    'etapas.agregarEtapas': 'Crear Etapas',
    'etapas.modificarEtapas': 'Editar Etapas',
    'etapas.etapaId': 'Etapa Id',
    'etapas.empresaId': 'Empresa Id',
    'etapas.etapaDescripcion': 'Etapa Descripción',
    'etapas.VerEtapas': 'Ver Etapas',
    'etapas.CambioEtapa': 'Esta seguro de cambiar la etapa del documento',
    'etapas.EtapaInactivo': 'Registro de etapa inactivo, seleccione uno nuevo'
};
